import genererPositionnementCheque from '@/services/parametrage/generation/genererPositionnementCheque';

export default function genererDomiciliationBancaire() {
  return {
    libelle: null,
    titulaire: null,
    codeBanque: null,
    codeGuichet: null,
    numeroCompte: null,
    cleRib: null,
    iban: '',
    codeSwift: null,
    libelleBanque: null,
    numCpta: null,
    codeJournal: null,
    actif: true,
    interfaceComptable: true,
    compteEscompte: null,
    compteEscompteTva: null,
    ribSepaId: null,
    societeId: null,
    libelleEcritureReglement: null,
    libelleEcriturePaiement: null,
    libelleLigneEcritureReglementTiers: null,
    libelleLigneEcritureReglementBanque: null,
    libelleReferencePaiementTiers: null,
    libelleReferencePaiementBanque: null,
    libelleReferenceReglementTiers: null,
    libelleReferenceReglementBanque: null,
    libelleLigneEcriturePaiementTiers: null,
    libelleLigneEcriturePaiementBanque: null,
    domBancaireReglement: [],
    positionnement: genererPositionnementCheque(),
  };
}
